import React from "react";
import { AppProvider } from "./shared/AppProvider";
import { store } from "../store/store";
import { queryClient } from "../api/queryClient";
import { history } from "../history";
import ScrollToTop from "../shared/ScrollToTop/ScrollToTop";
import { Router } from "../router/Router";
import { Notifications } from "../widgets/Notifications/Notifications";
import { GlobalPopups } from "../widgets/GlobalPopups/GlobalPopups";
import { ErrorBoundary } from "../widgets/ErrorBoundary/ErrorBoundary.js";
import { InactivityModal } from "../widgets/InactivityModal";
import { isAutoLogoutFeatureAvailable } from "../helpers/featureFlags.js";

export const App = () => {
  return (
    <ErrorBoundary>
      <AppProvider store={store} queryClient={queryClient} history={history}>
        <ScrollToTop />
        <Notifications />
        <GlobalPopups />
        <Router />
        {isAutoLogoutFeatureAvailable() && <InactivityModal />}
      </AppProvider>
    </ErrorBoundary>
  );
};
